import styled, { css } from 'styled-components';

const FullscreenSidebarHeader = styled.div<{
    backgroundColor?: string;
}>(({ backgroundColor = 'transparent' }) => {
    return css`
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: ${backgroundColor};
    `;
});
export default FullscreenSidebarHeader;
